import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Navitems } from 'src/app/shared/topheader/Models/navitems.model';
import { NavBarMenuService } from '../topheader/service/nav-bar-menu.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { UserInfoService } from './Service/user-info.service';
import { MsalService } from '@azure/msal-angular';
interface Approver {
  approverRoleId: number;
  approverRoleDescription: string;
}

interface Module {
  module_Name: string;
  menuId: number;
  accessModuleMenu_Id: number;
  approvers: Approver[];
}

interface Role {
  roleId: number;
  roleDescription: string;
  modules: Module[];
}

@Component({
    selector: 'app-user-info',
    templateUrl: './user-info.component.html',
    styleUrls: ['./user-info.component.css'],
    standalone: false
})
export class UserInfoComponent implements OnInit {
  userRolesMapped: Role[] = []; // Array to store the roles and modules data

 
  roles: any;
  reports: any;
  appsMenu: any;
  eventSubscription: any;

  constructor(private bsModalRef: BsModalRef,
    private authService: AuthService, private navbarService: NavBarMenuService,private userInfoService: UserInfoService, private msalService: MsalService
  ) { }
  

  ngOnInit(): void {
    //const userId = '8486583@ups.com'; // user id or ad id
   const activeAccount = this.msalService.instance.getActiveAccount();
   const userId = activeAccount ? activeAccount.username.toString() : '';

    this.userInfoService.getUserAccessInfo(userId).subscribe(
      response => {
        this.userRolesMapped = response; 
      },
      error => {
        console.error('Error fetching user access data:', error);
      }
    );
  }

  close() {
    this.bsModalRef.hide();
  }

}